import { isNil } from './is-nil';


/**
 * Gets the value associated with the specified keyStack (path).
 *
 * @param valueObject The object from which we need to retrieve the value.
 * @param keyStack A list of parameters that will be returned; e.g. 'a.b' will return
 *                 the value of `object[a][b]` or `null` if it doesn't exist.
 * @param defaultValue The value to be returned if the value in keyStack doesn't exist
 */
export function tryGetValue<T>(valueObject: any, keyStack: string, defaultValue: T | null = null): T | null {
  if (!keyStack || keyStack === '') {
    return defaultValue;
  }

  if (isNil(valueObject, keyStack)) {
    return defaultValue;
  }

  let currentValue: any = valueObject;
  for (let key of keyStack.split('.')) {
    currentValue = currentValue[key];
  }

  return currentValue as T;
}
